export const EVENT_DETAIL_STATE = 'app.entity.event.detail';

export const ownEventsFutureState = {
  name: 'app.my-events.**',
  url: '/my-event',
};
